<div class="navblock">
    <div class="btn_tabs">
        <button [ngClass]="{active: viewMode =='cards'}" (click)="viewMode='cards'">{{'Cards'|translate }}</button>
        <button [ngClass]="{active: viewMode =='table'}" (click)="viewMode='table'">{{'Table'|translate }}</button>
        <button [ngClass]="{active: viewMode =='panel'}" (click)="viewMode='panel'">{{'Events'|translate }}</button>
    </div>
    <div></div>
    <div class="inputgroup">
        <app-objects-filter></app-objects-filter>
    </div>
    <app-group-filter #groupFilter [isEditable]="false"></app-group-filter>
    <div>
        <button class="btn_img_large btn_warning_off" title="{{'Show alarms only' | translate}}"></button>
    </div>
</div>

<div class="tablewrap resizetable">
    <app-devices-list [hiddenMode]="true"></app-devices-list>
    <div class="table" id="dataarea">
        <table fixedcols="[]" id="dispatchertable" [ngStyle]="{display: (viewMode =='table') ? '': 'none'}">
            <tr>
                <th class="object_column">{{'Object'|translate}}</th>
                <th class="object_column">{{'Zone'|translate}}</th>
                <th class="datetime_column">{{'Time'|translate}}</th>
                <th class="object_column">{{'Parameter'|translate}}</th>
                <th class="avg_column">{{'Value'|translate}}</th>
                <th class="avg_column">{{'Permitted interval'|translate}}</th>
                <th class="avg_column">{{'Power'|translate}}</th>
                <th class="avg_column">{{'Battery'|translate}}</th>
                <th class=""></th>
            </tr>
        </table>

        <div class="dispatcher-cards" [ngStyle]="{display: (viewMode =='cards') ? '': 'none'}"></div>

        <div class="dispatcher-panel" [ngStyle]="{display: (viewMode =='panel') ? '': 'none'}">
            <div class="objdropdown dropdown dropclick dropclickjs cardmenu">
                <ul>
                    <li>{{ 'Show on the map' | translate }}</li>
                    <li>{{ 'Send command to device' | translate }}</li>
                    <li>{{ 'Acknowledge' | translate }}</li>
                </ul>
            </div>

            <div class="panel-cards">

            </div>

            <div class="table">
                <table fixedcols="[]" id="paneltable">
                    <tr>
                        <th class="object_column">{{'Object'|translate}}</th>
                        <th class="">{{'Address'|translate}}</th>
                        <th class="avg_column">{{'Ignition'|translate}}</th>
                        <th class="speed_column">{{'Speed'|translate}}</th>
                        <th class="avg_column">{{'Satellites'|translate}}</th>
                        <th class="datetime_column">{{'Time'|translate}}</th>
                        <th class=""></th>
                    </tr>
                </table>
            </div>
        </div>

    </div>
</div>
<div class="tablenav">
    <app-pagination [viewmode]="'print reports excel'" [printElementID]="'dataarea'"></app-pagination>
</div>

<template #mgmtDialog></template>
